module.exports = "/images/gotham-10.jpg";